import { InputBaseClasses, getInputBaseUtilityClass, inputBaseClasses as muiInputBaseClasses } from '@mui/material';

declare module '@mui/material/InputBase' {
  interface InputBasePropsSizeOverrides {
    small: true;
    medium: true;
    large: true;
  }

  interface InputBaseClasses {
    sizeMedium: string;
    sizeLarge: string;
  }
}

export const inputBaseClasses: InputBaseClasses = {
  ...muiInputBaseClasses,
  sizeMedium: getInputBaseUtilityClass('sizeMedium'),
  sizeLarge: getInputBaseUtilityClass('sizeLarge'),
};
